package org.hs_soft.runmynesto.pages.components.dialog.dialog

import androidx.compose.runtime.Composable
import androidx.compose.web.events.SyntheticMouseEvent
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Spacer
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.silk.components.text.SpanText
import org.hs_soft.runmynesto.domain.config.Dimen
import org.hs_soft.runmynesto.domain.config.FontFamily
import org.hs_soft.runmynesto.domain.config.FontSizes
import org.hs_soft.runmynesto.domain.config.Theme
import org.hs_soft.runmynesto.domain.config.backgroundDialog
import org.hs_soft.runmynesto.domain.config.generalDialogSetting
import org.hs_soft.runmynesto.domain.model.general.WindowSizeModeEnum
import org.hs_soft.runmynesto.pages.components.CustomEditText
import org.hs_soft.runmynesto.pages.components.dialog.component.DialogTitle
import org.hs_soft.runmynesto.pages.components.dialog.component.SubmitButtons
import org.jetbrains.compose.web.attributes.InputType
import org.jetbrains.compose.web.css.CSSSizeValue
import org.jetbrains.compose.web.css.CSSUnit
import org.jetbrains.compose.web.css.LineStyle

@Composable
fun AddRecordDialog(
    windowSizeMode: WindowSizeModeEnum,
    dialogTitle:String,
    nameFieldTitle:String,
    nameValue:String,
    height: CSSSizeValue<CSSUnit.px> =Dimen.addRecordDialogHeight,
    nameHint:String,
    numberHint:String,
    numberFieldTitle:String="",
    showNumberField:Boolean,
    numberValue:String="",
    isSubmitClickable:Boolean,
    loading:Boolean,
    isNameRequired:Boolean=true,
    isNumberRequired:Boolean=true,
    onNumberValueChange:(String)->Unit={},
    onNameValueChange:(String)->Unit,
    onCancelClick: () -> Unit,
    onSubmitClick:()->Unit,
    onBackgroundClick: () -> Unit,

)
{
    Box(
        modifier = Modifier
            .backgroundDialog()
            .onClick {
                onBackgroundClick()
            }
    )
    {
        Box(
            modifier = Modifier
                .align(Alignment.Center)
                .border(
                    width = Dimen.smallThickness,
                    style = LineStyle.Solid,
                    color = Theme.Transparent.rgb
                )
                .width(Dimen.addRecordDialogPhoneWidth)
                .height(height)
        ){
            Column(
                modifier = Modifier
                    .align(Alignment.Center)
                    .onClick {
                        event: SyntheticMouseEvent -> event.stopPropagation()
                    }
                    .fillMaxSize()
                    .generalDialogSetting()
            )
            {
                DialogTitle(
                    title = dialogTitle,
                    showCloseIcon = true,
                    showSeparator = false,
                    onCloseClick = {
                        onCancelClick()
                    }
                )

                Column(
                    modifier = Modifier
                        .fillMaxSize()
                        .padding(Dimen.extraLargePadding)
                )
                {
                    if (showNumberField){
                        CustomEditText(
                            fillMaxWidth = true,
                            isRequired = isNumberRequired,
                            label = numberFieldTitle,
                            value =numberValue,
                            hint = numberHint,
                            isOutlinedEditText = true,
                            onFocusIn = {},
                            onFocusOut = {},
                            onInputChange = {it, validation ->
                                onNumberValueChange(it)
                            },

                        )

                    }

                    CustomEditText(
                        label = nameFieldTitle,
                        fillMaxWidth = true,
                        value =nameValue,
                        hint = nameHint,
                        isRequired = isNameRequired,
                        inputType = InputType.Text,
                        isOutlinedEditText = true,
                        onFocusIn = {},
                        onFocusOut = {},
                        onInputChange = {it,_ ->
                            onNameValueChange(it)
                        },
                    )

                    Spacer()

                    SubmitButtons(
                        windowSize=windowSizeMode,
                        isSubmitClickable = isSubmitClickable,
                        loading = loading,
                        arrangement= Arrangement.Center,
                        onCancelClick = {
                            onCancelClick()
                        },
                        onSubmitClick = {
                            onSubmitClick()
                        },
                    )


                }



            }


        }

    }


}



